import { cloneDeep, isEqual } from 'lodash'

import { virginRecord } from '@/store/record/state'

export const RecordEditState = {
  recordEdit: {
    edited: null,
    original: null,
  },
}

export const RecordEditGetters = {
  edited: state => state.recordEdit.edited,
  original: state => state.recordEdit.original,
  wasChanged: state => !isEqual(
    state.recordEdit.edited,
    state.recordEdit.original
  ),
}

export const RecordEditMutations = {
  setEdited: (state, value) => {
    state.recordEdit.edited = {
      ...cloneDeep(virginRecord),
      ...cloneDeep(value),
    }
  },

  setOriginal: (state, value) => { state.recordEdit.original = cloneDeep(value) },
}

export const RecordEditActions = {
  resetEdited: ({ commit, dispatch, state }) => {
    commit('setEdited', state.recordEdit.original)
    dispatch('legalCase/resetEdited', null, { root: true })
  },
  setEdited: ({ commit }, value) => commit('setEdited', value),
  setOriginal: ({ commit }, value) => commit('setOriginal', value),
}
